import React from "react";
import { UseFormReturn } from "react-hook-form";
import { MoneyApi } from "go-core/api/types";
import CustomTipInput from "./CustomTipInput";
import CustomTipSectionHeader from "./CustomTipSectionHeader";

interface Props {
	form: UseFormReturn<{ tip: MoneyApi }>;
}

const CustomTipSection = ({ form }: Props) => {
	return (
		<section className="custom-tip-section">
			<CustomTipSectionHeader />
			<CustomTipInput form={form} />
		</section>
	);
};

export default CustomTipSection;
